// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"252e549c","577":"180d726a","951":"a603407a"}[chunkId] + ".chunk.js";
};